document.addEventListener("DOMContentLoaded", function () {
  const faqSections = document.querySelectorAll(".new-faq");

  faqSections.forEach(function (section) {
    const faqItems = section.querySelectorAll(".new-faq__question");

    faqItems.forEach(function (item) {
      item.addEventListener("click", function () {
        const isExpanded = this.getAttribute("aria-expanded") === "true";
        const answer = this.nextElementSibling;
        const currentItem = this.closest(".new-faq__item");

        // Close all other items within this section
        faqItems.forEach(function (otherItem) {
          const otherFaqItem = otherItem.closest(".new-faq__item");
          if (
            otherFaqItem !== currentItem &&
            otherFaqItem.classList.contains("is-active")
          ) {
            otherItem.setAttribute("aria-expanded", "false");
            otherFaqItem.classList.remove("is-active");
            otherItem.nextElementSibling.style.maxHeight = "0";
          }
        });

        this.setAttribute("aria-expanded", !isExpanded);
        currentItem.classList.toggle("is-active");

        if (!isExpanded) {
          answer.style.maxHeight = answer.scrollHeight + "px";
        } else {
          answer.style.maxHeight = "0";
        }
      });
    });
  });
});
